<template>
  <div class="container pb-5">
    <div class="d-flex justify-content-center">
      <div class="card card-container rounded-3 shadow w-100">
        <form class="card-body p-5" @submit.prevent="doLogin">
          <div v-show="!twoStep">
            <div class="text-center mx-3 mb-5">
              <span class="card-title h4 fw-bold">仲介業者向けシステム ログイン</span>
            </div>
            <div class="d-grid gap-3 mb-1">
              <div>
                <input class="form-control" type="email" placeholder="メールアドレス" aria-label="メールアドレス"
                      v-model="broker.email" :class="{'is-invalid': emailErrorMessage}"
                >
                <div class="invalid-feedback">{{ emailErrorMessage }}</div>
              </div>
              <div>
                <input class="form-control" type="password" placeholder="パスワード" aria-label="パスワード"
                      v-model="broker.password" :class="{'is-invalid': passwordErrorMessage}"
                >
                <div class="invalid-feedback">{{ passwordErrorMessage }}</div>
              </div>
              <div class="invalid-feedback text-center mt-0" :class="{'d-block': authErrorMessage}">
                {{ authErrorMessage }}
              </div>
              <login-button />
            </div>
            <div class="text-end small">
              <router-link :to="{name:'ForgotPassword'}">ログインにお困りの方</router-link>
            </div>
            <hr>
            <div class="text-center small" style="white-space: pre-wrap">
              <router-link :to="{name:'PrivacyPolicyAgreement'}">{{guestMessage}}</router-link>
            </div>
          </div>
          <div v-show="twoStep">
            <div class="d-grid gap-3 mb-1">
              <p>
                ご登録のメールアドレス宛にメールを送信しました。<br>
                メールに記載されている確認コードを入力して、送信ボタンを押下してください。（有効時間：１０分間）<br>
              </p>
              <div>
                <input class="form-control" type="password" placeholder="確認コード" aria-label="確認コード"
                      v-model="broker.token" :class="{'is-invalid': tokenErrorMessage}"
                >
                <div class="invalid-feedback">{{ tokenErrorMessage }}</div>
              </div>
              <div class="invalid-feedback text-center mt-0" :class="{'d-block': authErrorMessage}">
                {{ authErrorMessage }}
              </div>
              <send-button />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import LoginButton from '@/views/molecules/buttons/LoginButton';
import SendButton from '@/views/molecules/buttons/SendButton';

export default {
  name: "Login",
  data() {
    return {
      broker: {
        email: '',
        password: '',
        token: ''
      }
    }
  },
  components: {
    LoginButton,
    SendButton,
  },
  inject: [
    '$axios'
  ],
  mounted() {
    this.$store.commit('account/resetData');
    this.$store.commit('mail_history_index/resetData');
    this.$root.showFlashMessage();
  },
  computed: {
    passwordErrorMessage() {
      return this.errors?.password?.[0];
    },
    emailErrorMessage() {
      return this.errors?.email?.[0];
    },
    authErrorMessage() {
      return this.errors?.auth?.[0];
    },
    tokenErrorMessage() {
      return this.errors?.token?.[0];
    },
    twoStep() {
      return this.two_step ?? false;
    },
    ...mapState('account', [
      'errors',
      'two_step'
    ]),
    ...mapState('login_form', {
      isOwnerAllowed: state => state.is_owner_allowed,
    }),
    guestMessage() {
      if(this.isOwnerAllowed) {
        return 'システムの利用登録がされていない仲介業者、'+'\n'+'または所有者の方はこちら';
      }else{
        return "システムの利用登録がされていない仲介業者の方はこちら";
      }
    },
  },
  methods: {
    doLogin() {
      this.$store.dispatch('account/validate', {token: this.broker.token, isTwoStep: this.two_step}).then(() => {
        this.$store.dispatch('account/login', {email: this.broker.email, password: this.broker.password, token: this.broker.token}).then(() => {
          if (this.two_step) return;
          this.$router.push(this.$route.query.redirect ?? {name: 'Top'});
        }).catch(reason => this.$root.failApi(reason));
      }).catch(() => {});
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 32rem;
}
</style>
